import OrderSummary from '@screens/order/summary'

export default function OrderSummaryPage() {
  return <OrderSummary />
}
